const renewables = [
    {label: 'Monthly', value: 'monthly'},
    {label: 'Quarterly', value: 'quarterly'},
    {label: 'Annually', value: 'annually'},
];

export default renewables;
  